// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import { SUPPORT_TIER_BACKEND_NAME, SUPPORT_TIER_FREE } from '../../constants';
import { SelectField } from '../../formik-utils/FormFields';
import {
  getDropdownOptionsFromArray,
  getIfEstimateHasActiveCCStarterCommit,
} from '../../common-utils/utils';
import { EstimateContext } from '../../contexts/EstimateContext';

export const SupportTiersContainer = () => {
  const estimateData = useContext(EstimateContext);
  const { values } = useFormikContext();
  const hasActiveCCStarterCommit = getIfEstimateHasActiveCCStarterCommit(values);

  let supportTiers = estimateData.commit_config.support_tiers;
  // Free is unconditionally rejected by the backend whenever a CC Starter Commit package is
  // active (no admin override - see estimate_service.go's support tier guard), so it's filtered
  // out of the picker rather than letting the user hit a late save-time error.
  if (hasActiveCCStarterCommit) {
    supportTiers = supportTiers.filter((tier) => tier !== SUPPORT_TIER_FREE);
  }
  const supportTiersOptions = getDropdownOptionsFromArray(supportTiers);
  const supportTiersConfig = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(SUPPORT_TIER_BACKEND_NAME);

  return (
    <SelectField
      fieldDisplayName={supportTiersConfig.displayName}
      fieldName={supportTiersConfig.backendFieldName}
      options={supportTiersOptions}
    />
  );
};
